import script from "./ContentEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ContentEditor.vue?vue&type=style&index=0&id=3f4b2441&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4b2441"]])

export default __exports__